import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as _get, isEmpty as _isEmpty } from 'lodash';
import CustomFonts from '../../../../../../../../componentLibrary/FontSelect/CustomFonts';
import ElementErrorSign from '../../../../../../../../componentLibrary/ElementErrorSign';
import { elementContentType } from '../../../../../../../../types';

class ButtonElement extends PureComponent {
    state = {
        text: '',
        align: '',
        fontFamily: '',
        fontID: null,
        fontSize: '',
        lineHeight: '',
        fontStyle: '', // normal or italic
        fontWeight: '', // normal or bold
        textDecoration: '',
        color: '',
        backgroundColor: '',
        innerHorizontalPadding: 0,
        innerVerticalPadding: 0,
        borderRadius: '',
        horizontalInnerPadding: 0,
        verticalInnerPadding: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
    };

    // To handle undo redo gracefully both on mount and later updates
    static getDerivedStateFromProps(nextProps, prevState) {
        const { content } = nextProps;
        const {
            text,
            align,
            fontFamily,
            fontID,
            fontSize,
            lineHeight,
            fontStyle,
            fontWeight,
            textDecoration,
            color,
            backgroundColor,
            innerHorizontalPadding,
            innerVerticalPadding,
            borderRadius,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        } = content;
        const newState = {
            ...prevState,
            text,
            align,
            fontFamily,
            fontID,
            fontSize,
            lineHeight,
            fontStyle,
            fontWeight,
            textDecoration,
            color,
            backgroundColor,
            borderRadius,
            innerHorizontalPadding,
            innerVerticalPadding,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        };

        if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
            return { ...newState };
        }

        return { ...prevState };
    }

    render() {
        const {
            text,
            align,
            fontFamily,
            fontID,
            fontSize,
            lineHeight,
            fontStyle,
            fontWeight,
            textDecoration,
            color,
            backgroundColor,
            borderRadius,
            innerHorizontalPadding,
            innerVerticalPadding,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        } = this.state;
        const { isCustomFontsLoaded, customFonts } = this.props;
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0" tabIndex="0">
                <tbody>
                    <tr>
                        {
                            /*
                             * We are short-circuiting here if custom fonts are not loaded and if the element does not have fontID in the blocks data.
                             * If these two conditions pass, we check among all the custom fonts if the fontFamily and fontID that are in this element
                             * can be found. If not, either the value from the custom font was changed in the database or the fontID is not in the
                             * custom fonts array, which means that the font was unlinked from the users account.
                             */
                            isCustomFontsLoaded &&
                                fontID &&
                                !customFonts.some(({ fontID: id, value }) => id === fontID && value === fontFamily) && (
                                    <ElementErrorSign
                                        dataFor="button-custom-fonts-warning"
                                        tooltipMsg="Reselect your custom font in the text tool bar. If it isn’t on the list, contact your Account Manager to add it."
                                    />
                                )
                        }
                        <td
                            align={align}
                            verticalalign="middle"
                            style={{
                                fontSize: 0,
                                paddingTop,
                                paddingRight,
                                paddingBottom,
                                paddingLeft,
                                wordBreak: 'break-word',
                            }}
                        >
                            <table
                                align={align}
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                role="presentation"
                                style={{ borderCollapse: 'separate', lineHeight: '100%' }}
                            >
                                <tbody>
                                    <tr>
                                        <td
                                            align="center"
                                            valign="middle"
                                            bgcolor={backgroundColor}
                                            role="presentation"
                                            style={{
                                                borderRadius,
                                                padding: `${innerVerticalPadding}px ${innerHorizontalPadding}px`,
                                            }}
                                        >
                                            <p
                                                style={{
                                                    Margin: 0,
                                                    marginTop: 0,
                                                    marginBottom: 0,
                                                    backgroundColor,
                                                    color,
                                                    fontFamily,
                                                    fontSize,
                                                    fontStyle,
                                                    fontWeight,
                                                    lineHeight,
                                                    textDecoration,
                                                }}
                                            >
                                                {text}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = (state) => {
    const hasCustomFontsEnabled = _get(state, 'session.user.features.EMAIL_DESIGNER_CUSTOM_FONTS', false);
    const isCustomFontsLoaded = _get(state, 'customFonts.isLoaded', false);
    const customFontsData = _get(state, 'customFonts.data', {});

    return {
        isCustomFontsLoaded,
        customFonts:
            hasCustomFontsEnabled && isCustomFontsLoaded && !_isEmpty(customFontsData)
                ? new CustomFonts(customFontsData)
                : [],
    };
};

ButtonElement.propTypes = {
    isCustomFontsLoaded: PropTypes.bool.isRequired,
    customFonts: PropTypes.array.isRequired,
    content: elementContentType.isRequired,
};

export default connect(mapStateToProps)(ButtonElement);
